export const SET_MANAGERS = "SET_MANAGERS"